import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../../../../../Controllers/Store";
import { useSelector } from "react-redux";

import { Ripple } from "primereact/ripple";
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputNumberChangeEvent } from "primereact/inputnumber";

import NoDataCreated from "../../../../../Components/NoDataCreated";
import DocumentViewModal from "../../../../../Components/DocumentViewModal";
import FileInput from "../../../../../Components/FileInput";
import ErrorPage from "../../../../../Components/ErrorPage";
import PageLoader from "../../../../../Components/PageLoader";
import NumberInput from "../../../../../Components/NumberInput";
import { goToTop } from "../../../../../Components/goToTop";
import { hasPermission } from "../../../../../Controllers/Selectors/permissionsSelector";
import { checkFileOthers, checkNumber } from "../../../../../Utils/Validator";

import { ValuationFeatureData, Valuations } from "../../../../../Controllers/Types/Project/DefaultService/ValuationInterface";
import {
    valuationCreateAPI,
    valuationDeleteAPI,
    valuationFeatureFileRemoveAPI,
    valuationFeatureFileUploadAPI,
    valuationGetDataApi
} from "../../../../../Api/Project/DefaultServices/ValuationApi";

const Valuation: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const projectData = location.state?.data;
    const serviceId = Number(projectData.folder_id);
    const [dataLoading, setDataLoading] = useState<boolean>(false);
    const [initialDataloading, setInitialDataLoading] = useState<boolean>(true);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    // const isShared: boolean = projectData.sharedBy !== null ? true : false;
 const isShared: boolean = projectData.can_edit===false ? true : false;

    const [dataState, setDataState] = useState<'Add' | 'Edit'>('Add');
    const [loading, setLoading] = useState<boolean>(false);

    const [showDocumentViewModal, setShowDocumentViewModal] = useState(false);
    const [fileUrl, setFileUrl] = useState<string | null>(null);

    const [valuationData, setValuationData] = useState<Valuations[]>([]);
    const [selectedValId, setSelectedValId] = useState<number | null>(null);
    const [selectedValData, setSelectedValData] = useState<Valuations | null>(null);
    const [selectedValuationFeatureDataId, setSelectedValuationFeatureDataId] = useState<number | null>(null);

    const [showUploadModal, setShowUploadModal] = useState<boolean>(false);
    const [uploadedFile, setUploadedFile] = useState<File | null>(null);
    const [uploadedFileName, setUploadedFileName] = useState<string>('');
    const [fileUploadError, setFileUploadError] = useState<string>('');
    const [selectedFileId, setSelectedFileId] = useState<number | null>(null);

    const [showValuationModal, setShowValuationModal] = useState<boolean>(false);
    const [valuationNumber, setValuationNumber] = useState<number | null>(null);
    const [valuationNumberError, setValuationNumberError] = useState<string>('');

    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermission_progress_options = useCanEdit('Valuation', 'progress_options');
    const isPermission_add_valuation = useCanEdit('Valuation', 'add_valuation');
    const isPermission_edit_valuation = useCanEdit('Valuation', 'edit_valuation');
    const isPermission_delete_valuation = useCanEdit('Valuation', 'delete_valuation');
    const isPermission_upload_files = useCanEdit('Valuation', 'upload_files');
    const isPermission_delete_file = useCanEdit('Valuation', 'delete_file');


    useEffect(() => {
        valuationDataGet();
    }, [serviceId]);


    /* ********************************* get data list ************************************************** */
    const valuationDataGet = async () => {
        if (!serviceId) return;

        try {
            setDataLoading(true);
            const data = await valuationGetDataApi(Number(serviceId));
            setDataLoading(false);
            setInitialDataLoading(false);

            if (data.status) {
                const dataList: Valuations[] = data.data || [];
                setValuationData(dataList);

                if (dataList.length > 0) {
                    let selectedData: Valuations | undefined;

                    if (selectedValId) {
                        selectedData = dataList.find(contact => contact.id === selectedValId);
                    }

                    if (selectedData) {
                        setSelectedValData(selectedData);
                        setSelectedValId(selectedData.id);
                    } else {
                        setSelectedValData(dataList[0]);
                        setSelectedValId(dataList[0].id);
                    }
                }
            } else {
                setErrorMessage(
                    `An error occurred while retrieving ${(projectData?.feature_name || "valuation").toLowerCase()} document data.`
                );
            }
        } catch (error) {
            setDataLoading(false);
            setInitialDataLoading(false);
            setErrorMessage("An unexpected error occurred while fetching valuation data.");
        }
    };

    /* ********************************* get data list ************************************************** */

    /* ******************************* For Valuation ***************************** */
    const handleSetValuationNumber = () => {
        if (valuationData && valuationData.length > 0) {
            const lastValuation = valuationData[valuationData.length - 1];
            setValuationNumber((lastValuation?.valuation_no || 0) + 1);
        } else {
            setValuationNumber(1);
        }
    };


    const handleAddValuation = () => {
        setDataState('Add');
        setShowValuationModal(true);

        handleSetValuationNumber()
    }

    const handleClearFields = () => {
        setValuationNumber(null);
    }

    const handleClearErrors = () => {
        setValuationNumberError('');
    }

    const handleCloseValuationModal = () => {
        setShowValuationModal(false);
        handleClearFields();
        handleClearErrors();
    }


    /* ********************************************************** valuation Create ************************************************ */
    useEffect(() => {
        checkNumber(valuationNumber!, false, setValuationNumberError);
    }, [valuationNumber]);

    function checkCredentials(): boolean {
        const isValuationNumberValid = checkNumber(valuationNumber!, true, setValuationNumberError);

        return isValuationNumberValid;
    }

    const handleCreateValuation = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {
            setLoading(true);
            const data = await valuationCreateAPI(Number(serviceId), valuationNumber);

            setLoading(false);
            if (data.statusCode === 200) {
                valuationDataGet();
                handleCloseValuationModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Valuation created successfully.`,
                        life: 3000,
                    });
                }
            } else if (data.statusCode === 422) {
                Object.entries(data.errors ?? []).map(([key, value], index) => (
                    setValuationNumberError(value[0])
                ))
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error creating valuation.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* ********************************************************** valuation Create ************************************************ */


    /* ********************************************************** valuation Feature File Upload ************************************************ */
    useEffect(() => {
        checkFileOthers(uploadedFile!, false, setFileUploadError);
    }, [uploadedFile]);

    function checkCredentialFile(): boolean {
        const isUploadedFileValid = checkFileOthers(uploadedFile!, true, setFileUploadError);

        return isUploadedFileValid;
    }

    const handleSaveFileUpload = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialFile()) {
            setLoading(true);
            const data = await valuationFeatureFileUploadAPI(selectedValuationFeatureDataId!, uploadedFile!);
            setLoading(false);

            if (data.statusCode === 200) {
                valuationDataGet();
                handleCloseFileUploadModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `File uploaded successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error uploading file.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* ********************************************************** valuation Feature File Upload ************************************************ */


    /* ********************************************************** valuation Delete ************************************************ */
    const handleDeleteValuation = (valId: number) => {
        confirmDialog({
            message: (
                <div className="text-center d-flex justify-content-center flex-column">
                    <span>
                        Are you sure you want to delete the <b>valuation {selectedValData?.valuation_no}</b>?<br />
                        <small className="text-center text-secondary">All the files associate with this will also be deleted.</small>
                    </span>
                </div>
            ),
            header: 'Confirm the deletion',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteValuation(valId),
            dismissableMask: true,
            resizable: false,
            draggable: false,
        });
    }

    const deleteValuation = async (valId: number) => {
        const data = await valuationDeleteAPI(valId);

        if (data.statusCode === 200) {
            valuationDataGet();

            if (toast.current) {
                toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Valuation data deleted successfully.`,
                    life: 3000,
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'Error deleting valuation data.',
                    life: 3000
                });
            }
        }
    }
    /* ********************************************************** valuation Delete ************************************************ */


    /* ********************************************************** File Delete ************************************************ */
    const handleDeleteFile = (fileId: number) => {
        confirmDialog({
            message: `Are you sure you want to delete this file?`,
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteFile(fileId),
            dismissableMask: true,
            resizable: false,
            draggable: false,
        });
    }

    const deleteFile = async (fileId: number) => {
        const data = await valuationFeatureFileRemoveAPI(fileId);

        if (data.statusCode === 200) {
            valuationDataGet();
            setShowDocumentViewModal(false);

            if (toast.current) {
                toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `File deleted successfully.`,
                    life: 3000,
                });
            }
            setFileUrl('');
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'Error deleting the file.',
                    life: 3000
                });
            }
        }
    }
    /* ********************************************************** File Delete ************************************************ */


    const handleValuationNumberChange = (e: InputNumberChangeEvent) => {
        if (e.value != null) {
            setValuationNumber(e.value);
        } else {
            setValuationNumber(null);
        }
    };

    /* Modal header */
    const valuationModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Add valuation
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseValuationModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const valuationModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseValuationModal}
            />

            <Button
                label={loading ? 'Processing' : 'Create'}
                onClick={handleCreateValuation}
                loading={loading}
                className="custom_btn primary"
            />
        </div>
    );

    const handleSelectValuation = (valuation: Valuations) => {
        setSelectedValData(valuation);
        setSelectedValId(valuation.id);
    }
    /* *************************************************************************** */


    /* ******************************* For file upload *************************** */
    const handleOpenUploadFileModal = (valuationFeatureDataId: number) => {
        setShowUploadModal(true);
        setSelectedValuationFeatureDataId(valuationFeatureDataId);
    }

    const handleCloseFileUploadModal = () => {
        setShowUploadModal(false);
        handleClearFile();
        setFileUploadError('');
    }

    const handleFileUpload = (file: File) => {
        setUploadedFileName(file.name);
        setUploadedFile(file);
    };

    const handleClearFile = () => {
        setUploadedFileName('');
        setUploadedFile(null);
    };

    /* Modal header */
    const fileUploadModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Upload file
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseFileUploadModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const fileUploadModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseFileUploadModal}
            />

            <Button
                label={loading ? 'Processing' : 'Upload'}
                onClick={handleSaveFileUpload}
                loading={loading}
                className="custom_btn primary"
            />
        </div>
    );
    /* *************************************************************************** */


    /* ***************************** For view file ******************************* */
    const handleViewDocument = (valFeature: ValuationFeatureData) => {
        setFileUrl(valFeature.document_file!);
        setSelectedFileId(valFeature.id);
        setShowDocumentViewModal(true);
    }

    const handleCloseDocumentViewModal = () => {
        setShowDocumentViewModal(false);
    };
    /* *************************************************************************** */


    /* **************************** Common functions ***************************** */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    /* *************************************************************************** */

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {dataLoading ? (
                    <PageLoader />
                ) : errorMessage ? (
                    <ErrorPage errorMessage={errorMessage} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    {projectData.job_number} : {projectData.address}
                                </li>
                                <li className="page_breadcrumb_item has_child">
                                    {projectData.folder}
                                </li>
                                <li className="page_breadcrumb_item active">
                                    {projectData.feature_name}
                                </li>
                            </ul>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area justify-content-end mt-sm-3 mt-0">
                            <div className="page_action_area">
                                {valuationData?.length > 0 && (
                                    <React.Fragment>
                                        {isPermission_delete_valuation && !isShared && (
                                            <button className="data_view_mode_btn danger p-ripple" onClick={() => handleDeleteValuation(selectedValId!)}>
                                                <i className={`bi bi-trash3`}></i>
                                                <Ripple />
                                            </button>
                                        )}
                                    </React.Fragment>
                                )}

                                {isPermission_add_valuation && !isShared && (
                                    <button className="add_data_link_btn p-ripple" onClick={handleAddValuation}>
                                        <i className="bi bi-plus-circle"></i>
                                        <span>Add {(projectData.feature_name).toLowerCase()}</span>
                                        <Ripple />
                                    </button>
                                )}
                            </div>
                        </div>

                        {valuationData?.length > 0 ? (
                            <div className="row mt-sm-4 mt-3">
                                <div className="col-12 col-sm-4 col-xl-3 col-xxl-3">
                                    <div className="valuation_list_area">
                                        <ul className="valuation_list">
                                            {valuationData?.map((valuation) => (
                                                <li key={valuation.id}
                                                    className={`valuation_list_item ${selectedValData?.id === valuation.id ? 'active' : ''}`}>
                                                    <button className={`is_btn valuation_button p-ripple`}
                                                        onClick={() => handleSelectValuation(valuation)}>
                                                        Valuation&nbsp;{valuation.valuation_no}
                                                        <Ripple />
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-12 col-sm-8 col-xl-9 ps-sm-0">
                                    {selectedValData && selectedValData.valuation_feature_data && (
                                        <div className="valuation_detail_area">
                                            {selectedValData.valuation_feature_data.map((valuation_feature) => (
                                                <article key={valuation_feature.id} className="valuation_detail">
                                                    <h6 className="valuation_detail_title">
                                                        {valuation_feature.valuation_feature.feature_name}
                                                    </h6>

                                                    {valuation_feature.document_file === null ? (
                                                        <React.Fragment>
                                                            {!isShared ? (
                                                                <Button
                                                                    icon="bi bi-arrow-up-circle-fill"
                                                                    label="Upload"
                                                                    className="upload_btn"
                                                                    onClick={() => handleOpenUploadFileModal(valuation_feature.id)}
                                                                    disabled={!isPermission_upload_files}
                                                                />
                                                            ) : (
                                                                <Button
                                                                    icon="bi bi-file-earmark-minus"
                                                                    className="upload_view_btn"
                                                                    disabled
                                                                />
                                                            )}
                                                        </React.Fragment>
                                                    ) : (
                                                        <Button
                                                            icon="bi bi-file-earmark-pdf"
                                                            className="upload_view_btn"
                                                            onClick={() => handleViewDocument(valuation_feature)}
                                                        />
                                                    )}
                                                </article>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="page_main_content_section">
                                <NoDataCreated
                                    message={`No ${(projectData.feature_name).toLowerCase()} added. ${!isShared && isPermission_add_valuation ? `To add the ${(projectData.feature_name).toLowerCase()} click on add button.` : ''}`}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div >


            {/* Document upload modal */}
            <Dialog
                header={fileUploadModalHeader}
                headerClassName="custom_modal_header"
                footer={fileUploadModalFooter}
                visible={showUploadModal}
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseFileUploadModal}>
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-3 pt-sm-2 pb-sm-0 w-100">
                        <div className="row">
                            <div className="col-12">
                                <FileInput
                                    id="uploadedFile"
                                    label="Upload file"
                                    labelHtmlFor="uploadedFile"
                                    required={true}
                                    value={uploadedFileName}
                                    onUpload={handleFileUpload}
                                    onClear={handleClearFile}
                                    toast={toast}
                                    containerClassName="mb-0"
                                    error={fileUploadError}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>


            {/* valuation modal */}
            <Dialog
                visible={showValuationModal}
                header={valuationModalHeader}
                headerClassName="custom_modal_header"
                footer={valuationModalFooter}
                dismissableMask
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseValuationModal}>
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-3 pt-sm-2 pb-sm-0 w-100">
                        <div className="row">
                            <div className="col-12">
                                {/* Valuation number */}
                                <NumberInput
                                    inputId="valuationNumber"
                                    label="Valuation number"
                                    labelHtmlFor="valuationNumber"
                                    placeholder="Valuation number"
                                    onChange={handleValuationNumberChange}
                                    value={valuationNumber}
                                    required={true}
                                    minFractionDigits={0}
                                    maxFractionDigits={0}
                                    min={0}
                                    prefix="Valuation "
                                    error={valuationNumberError}
                                    formGroupClassName="mb-3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>


            {/* Document view modal */}
            <DocumentViewModal
                isOpen={showDocumentViewModal}
                onClose={handleCloseDocumentViewModal}
                fileUrl={fileUrl!}
                hasDelete={isPermission_delete_file && !isShared}
                onDelete={() => handleDeleteFile(selectedFileId!)}
            />
            {/*  */}
        </React.Fragment>
    )
}

export default Valuation;